<div class="popup-box">
  <div class="feedback-popup">
    <span class="icon-close" (click)="closeFeedback()"></span>
    <h2 class="h-special">{{ 'Feedback' | translate }}</h2>
    <div class="ctent-feedback">
      <p class="tit-feedback">{{ 'We always value your feedback' | translate }}</p>
      <p class="txt-feedback">{{ 'Thank you very much for helping us to make your city a quieter place to live.' | translate }}<br>
      {{ 'If you are curious and want to learn more about our story, explore the extra content provided in the menu.' | translate }}</p>
      <p class="txt-emotion">{{ 'How user-friendly the tool is:' | translate }}</p>
      <ul class="list-emotion clearfix">
        <li [title]="'Feedback - Unfriendly' | translate"><img src="assets/images/icon_emotion01_off.png" alt="" (click)="changeEmotion('1')"></li>
        <li><img src="assets/images/icon_emotion02_off.png" alt="" (click)="changeEmotion('2')"></li>
        <li><img src="assets/images/icon_emotion03_off.png" alt="" (click)="changeEmotion('3')"></li>
        <li><img src="assets/images/icon_emotion04_off.png" alt="" (click)="changeEmotion('4')"></li>
        <li [title]="'Feedback - Friendly' | translate"><img src="assets/images/icon_emotion05_on.png" alt="" (click)="changeEmotion('5')"></li>
      </ul>
      <p *ngIf="errorNotification" class="error-require">{{ messageNotificationEmail | translate }}</p>
      <input type="text" name="email" id="email" [placeholder]="'Email' | translate">
      <p *ngIf="errorNotification" class="error-require">{{ messageNotificationComment | translate }}</p>
      <textarea name="comment" id="comment" [placeholder]="'Enter your feedback here' | translate"></textarea>
      <div class="center"><button class="btn-feedback" (click)="sendFeedback()">{{ 'Submit' | translate }}</button></div>
    </div>
  </div>
</div>
<div class="bg-popup"></div>